

















































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '@/lib/util';
import AbpBase from '@/lib/abpbase';
import PageRequest from '@/store/entities/page-request';
import VWidget from '@/components/VWidget.vue';

class PageConceptRequest extends PageRequest {
    type: number = Util.abp.list.get('T_CONCEPT', 'CA').id;
}

@Component({
    components: { VWidget }
})
export default class Concepts extends AbpBase {
    entity: string = 'concept';
    pagerequest: PageConceptRequest = new PageConceptRequest();
    selected: any = null;

    get loading() {
        return this.$store.state.concept.loading;
    }

    get selectedType() {
        return Util.abp.list.getItem(this.pagerequest.type);
    }

    get items() {
        let code = (this.selectedType.code == 'CA' ? 'G_CAPACITY': 
            (this.selectedType.code == 'CI' ? 'G_FIGURE' : 'G_FEE')); 

        let items = Util.abp.list.getList(code);

        items.forEach(item => {
            item.list = this.$store.state.concept.list.filter(ls => { return ls.group_id == item.id });
        });

        return items;
    }

    get types() {
        return Util.abp.list.getList('T_CONCEPT');
    }

    async changeName(item) {
        await this.$store.dispatch({
            type: 'concept/update',
            data: item
        });
    }

    async getpage() {
        this.pagerequest.perPage = 100;
        this.pagerequest.page = 1;

        await this.$store.dispatch({
            type: 'concept/getAll',
            data: this.pagerequest
        });
    }

    mounted() {
        this.getpage();
    }

    created() {

    }
}